import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { Loading } from '~/components/Loading';

const Error = React.lazy(() =>
  import('./Error').then(({ Error }) => ({ default: Error })),
);
const Offer = React.lazy(() =>
  import('./Offer').then(({ Offer }) => ({ default: Offer })),
);
const JourneyClosed = React.lazy(() =>
  import('./JourneyClosed').then(({ JourneyClosed }) => ({
    default: JourneyClosed,
  })),
);
const Quiz = React.lazy(() =>
  import('./Quiz').then(({ Quiz }) => ({ default: Quiz })),
);
const QuizNegative = React.lazy(() =>
  import('./QuizNegative').then(({ QuizNegative }) => ({
    default: QuizNegative,
  })),
);
const RedirectToPortalDigital = React.lazy(() =>
  import('./RedirectToPortalDigital').then(({ RedirectToPortalDigital }) => ({
    default: RedirectToPortalDigital,
  })),
);
const IntroTermConfirm = React.lazy(() =>
  import('./IntroTermConfirm').then(({ IntroTermConfirm }) => ({
    default: IntroTermConfirm,
  })),
);
const RedirectToIframe = React.lazy(() =>
  import('./RedirectToIframe').then(({ RedirectToIframe }) => ({
    default: RedirectToIframe,
  })),
);
const IntroWelcomeWrapper = React.lazy(() =>
  import('./IntroWelcomeWrapper').then(({ IntroWelcomeWrapper }) => ({
    default: IntroWelcomeWrapper,
  })),
);

const Journey: React.FC = () => {
  return (
    <Switch>
      <Suspense fallback={<Loading />}>
        <Route exact path="/" component={IntroWelcomeWrapper} />
        <Route path="/intro" component={IntroTermConfirm} />
        <Route path="/quiz" component={Quiz} />
        <Route path="/quiznegative" component={QuizNegative} />
        <Route path="/offer" component={Offer} />
        <Route path="/journeyclosed" component={JourneyClosed} />
        <Route
          path="/redirectPortalDigital"
          component={RedirectToPortalDigital}
        />
        <Route path="/internal" component={RedirectToIframe} />
        <Route path="/error" component={Error} />
      </Suspense>
    </Switch>
  );
};

export default Journey;
